// Lightweight browser fingerprint for the "Trust this browser for 30 days"
// flow on the login screen.
//
// Hash of: user-agent + accept-language + screen resolution + timezone
// offset. Hashed with SHA-256 via the Web Crypto API so the raw
// components never travel to the backend and the fingerprint can't be
// reversed into PII. Same components on the same browser produce the
// same hash; any change (browser update that bumps UA, new monitor that
// changes screen resolution, etc.) invalidates the trust and forces
// re-verification — defense in depth.
//
// Falls back to '' (empty fingerprint) when Web Crypto isn't available
// (very old browsers or non-HTTPS contexts). An empty fingerprint never
// matches a trusted-device record, so the backend will require OTP
// verification as before — graceful degradation, never silently
// permissive.

export async function getDeviceFingerprint() {
  try {
    const parts = [
      navigator.userAgent || '',
      navigator.language || '',
      `${(window.screen && window.screen.width)  || 0}x${(window.screen && window.screen.height) || 0}`,
      String(new Date().getTimezoneOffset()),
    ];
    const text = parts.join('|');
    if (!window.crypto || !window.crypto.subtle) return '';
    const buf  = new TextEncoder().encode(text);
    const hash = await window.crypto.subtle.digest('SHA-256', buf);
    return Array.from(new Uint8Array(hash))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  } catch {
    return '';
  }
}
